export default __webpack_public_path__ + "static/forbes-f61d20f86cde4eb6a66fdaafd84534c5.svg";